import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { useConsultation } from './ConsultationContext';
interface ResultItem {
  image: string;
  label: string;
  labelPosition: 'top' | 'corner';
}
export function BeforeAfter() {
  const {
    openModal
  } = useConsultation();
  const results: ResultItem[] = [{
    image: 'https://cdn.magicpatterns.com/uploads/sU7S69Gtev4Eq9pakfj6gh/Glass_Skin_Mesotherapy4.png',
    label: 'Cellular Hydration',
    labelPosition: 'corner'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/77U4dAzXrRvZt3Y9NYqxw7/Glass_Skin_Mesotherapy1.webp',
    label: 'Under-Eye & Texture Refinement',
    labelPosition: 'top'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/rDMt6iJZ53PBfmCZRGUa9K/Glass_Skin_Mesotherapy3.jpg',
    label: 'Skin Smoothing & Radiance',
    labelPosition: 'top'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/8ejAdbWyfse6KHuMeHQrZz/2.jpg',
    label: 'Full Face Rejuvenation',
    labelPosition: 'top'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/aXMoqB9tUbhuyA4Uaty6RQ/Untitled_(2500_x_2500_px).jpg',
    label: 'Glass Skin Peel',
    labelPosition: 'top'
  }];
  return <section className="py-16 md:py-32 bg-cream-dark/30" data-id="element-16">
      <div className="container mx-auto px-4 md:px-6" data-id="element-17">
        <FadeIn data-id="element-18">
          <div className="text-center mb-10 md:mb-16" data-id="element-19">
            <h2 className="text-3xl md:text-4xl font-serif text-primary mb-4" data-id="element-20">
              Real Results
            </h2>
            <p className="text-foreground/70" data-id="element-21">
              The transformation of cellular hydration.
            </p>
          </div>
        </FadeIn>

        <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 md:gap-8 justify-items-center" data-id="element-22">
          {results.map((result, index) => <FadeIn key={index} delay={200 + index * 150} direction="up" data-id="element-23">
              <div className="relative rounded-2xl overflow-hidden shadow-md border border-divider group w-full" data-id="element-24">
                <div className="aspect-[4/5] overflow-hidden" data-id="element-25">
                  <img src={result.image} alt={`Before and after: ${result.label}`} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-26" />
                </div>

                {/* Frosted glass Before/After label */}
                {result.labelPosition === 'top' ? <div className="absolute top-0 inset-x-0 flex" data-id="element-27">
                    <div className="flex-1 bg-white/20 backdrop-blur-md border-b border-r border-white/30 py-2 px-3 text-center" data-id="element-28">
                      <span className="text-white text-xs font-bold uppercase tracking-widest drop-shadow-md" data-id="element-29">
                        Before
                      </span>
                    </div>
                    <div className="flex-1 bg-white/20 backdrop-blur-md border-b border-white/30 py-2 px-3 text-center" data-id="element-30">
                      <span className="text-white text-xs font-bold uppercase tracking-widest drop-shadow-md" data-id="element-31">
                        After
                      </span>
                    </div>
                  </div> : <>
                    <div className="absolute right-2 sm:right-3 top-[38%] sm:top-[40%] bg-white/20 backdrop-blur-md border border-white/30 rounded-full py-1 px-3 sm:px-4 text-center" data-id="element-32">
                      <span className="text-white text-[9px] sm:text-[10px] font-bold uppercase tracking-widest drop-shadow-md" data-id="element-33">
                        Before
                      </span>
                    </div>
                    <div className="absolute right-2 sm:right-3 bottom-[6%] sm:bottom-10 bg-white/20 backdrop-blur-md border border-white/30 rounded-full py-1 px-3 sm:px-4 text-center" data-id="element-34">
                      <span className="text-white text-[9px] sm:text-[10px] font-bold uppercase tracking-widest drop-shadow-md" data-id="element-35">
                        After
                      </span>
                    </div>
                  </>}

                {/* Bottom label */}
                <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/60 via-black/30 to-transparent p-4 sm:p-5 pt-10 sm:pt-12" data-id="element-36">
                  <p className="text-white/90 text-xs sm:text-sm font-medium tracking-wide" data-id="element-37">
                    {result.label}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={800} data-id="element-38">
          <div className="mt-10 md:mt-12 text-center flex flex-col items-center gap-6" data-id="element-39">
            <p className="text-sm text-foreground/60 italic" data-id="element-40">
              Results shown after standard 3-session protocol. Individual
              results may vary.
            </p>
            <Button onClick={openModal} data-id="element-41">Book A Consultation</Button>
          </div>
        </FadeIn>
      </div>
    </section>;
}